import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const StaffDeleteIntegrationModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "StaffDeleteIntegrationModalContainer" */
      './StaffDeleteIntegrationModalContainer'
    ),
  loading: LoadingModal,
});
